import { Modal } from "react-bootstrap";
import {
  faCheckCircle,
  faTimesCircle,
} from "@fortawesome/free-regular-svg-icons";
import { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const NewProcessingModal = ({ status, onClose }) => {
  const AUTO_CLOSE_TIME = 3000;

  const successIcon = (
    <FontAwesomeIcon
      icon={faCheckCircle}
      style={{ color: "#a5dc86", fontSize: 80, marginBottom: 20 }}
    />
  );
  const errorIcon = (
    <FontAwesomeIcon
      icon={faTimesCircle}
      style={{ color: "#ff2e2e", fontSize: 80, marginBottom: 20 }}
    />
  );

  useEffect(() => {
    if (status.status === "success" || status.status === "error") {
      const timer = setTimeout(() => {
        onClose();
      }, AUTO_CLOSE_TIME); // fallback seguro

      return () => clearTimeout(timer);
    }
  }, [status, onClose]);


  return (
    <Modal show={!!status.status} backdrop="static" animation={false} centered>
      <Modal.Body className="mt-2">
        <div className="d-flex flex-column justify-content-center align-items-center">
          {status.status === "processing" && (
            <>
              <h2 className="mt-5 mb-4">{status.message}</h2>
              <div className="d-flex mb-5">
                <span className="dot-pulse"></span>
                <span className="dot-pulse dot-pulse-delay-1"></span>
                <span className="dot-pulse dot-pulse-delay-2"></span>
              </div>
            </>
          )}
          {status.status === "success" && (
            <>
              {successIcon}
              <h2 className="mt-3 mb-5 text-success">{status.message}</h2>
            </>
          )}
          {status.status === "error" && (
            <>
              {errorIcon}
              <h2 className="mt-3 mb-5 text-danger">{status.message}</h2>
            </>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default NewProcessingModal;
